import { addCartPromoCode, getReviewOrder, fetchCartSummary, getShippingBilling, placeOrder, checkPONumber } from 'helpers/api';
import { formatMoney, hideCartIcon } from 'helpers/utils';
import { isProd } from 'config/config';

import Vue from 'vue/dist/vue';
import swal from 'sweetalert';

const reviewOrderEl = document.querySelector('#review-order');
if (reviewOrderEl) {
    new Vue({
        el: '#review-order',
        data: {
            res: null,
            fetchCartRes: null,
            shippingRes: null,
            poNumber: {
                field: '',
                error: false,
                num: 1,
            },
            promoCode: {
                field: '',
                currentValue: '',
                success: false,
                error: false,
            },
            isLoading: true,
            isFetching: false,
            HasError: false,
            submissionError: false,
            message: '',
        },
        filters: {
            formatMoney: function (price) {
                return formatMoney(price);
            },
        },
        computed: {
            isProd: function () {
                return isProd;
            },
            totalCost() {
                // Calculate the total cost by summing the prices of non-prohibited items
                return this.res.items.reduce((total, items) => {
                    if (!this.res.items.IsProhibitedState) {
                        total += this.res.items.ActualDealerCost * items.Quantity;
                    }
                    return total;
                }, 0);
            },
        },
        methods: {
            setValues: async function () {
                this.fetchCartRes = await fetchCartSummary();
                this.shippingRes = await getShippingBilling();
                const res = await getReviewOrder();

                this.res = res;

                if (this.res.status && this.res.status != 200) {
                    this.HasError = true;
                    this.isLoading = false;

                    swal('Notice', this.res.Message, 'error');

                    return;
                }

                if (this.res.PromoCode) {
                    this.promoCode.currentValue = this.res.PromoCode;
                    this.promoCode.success = true;
                }

                console.log('getReviewOrder -> res:');
                console.log(res);

                if (res.isProhibitedState) {
                    swal('Restricted Part Note', 'Restricted Part, Sale not allowed in specific States.', 'info');
                }

                this.isLoading = false;
            },
            updatePromo: async function (e, input = '') {
                e.preventDefault();

                const status = await addCartPromoCode(input);

                if (status !== 200) {
                    this.promoCode.error = true;
                    return;
                }

                this.promoCode.currentValue = input;
                this.promoCode.field = '';
                this.promoCode.error = false;

                if (input.length) {
                    this.promoCode.success = true;
                } else {
                    this.promoCode.success = false;
                }

                this.setValues();
            },
            validatePONumber: async function () {
                const value = this.poNumber.field.trim();

                if (!value.length) {
                    this.poNumber.error = false;
                    return true;
                }
                // NEW: format + length validation
                const regex = /^[a-zA-Z0-9_#-]{1,21}$/;

                if (!regex.test(value)) {
                    this.poNumber.error = true;
                    return false; // stop here, don't call API
                }
                // Format is now valid → clear error BEFORE async call
                this.poNumber.error = false;

                const isValid = await checkPONumber(this.poNumber.field);

                this.poNumber.error = !isValid;

                return isValid;
            },
            submitOrder: async function (e) {
                e.preventDefault();

                this.isFetching = true;
                let submitButton = document.getElementById('submit-order-button');
                submitButton.disabled = true;

                const isValidPONumber = await this.validatePONumber();

                if (!isValidPONumber) {
                    this.poNumber.error = true;
                    this.isFetching = false;
                    submitButton.disabled = false;
                    return;
                } else {
                    this.poNumber.error = false;
                }

                const res = await placeOrder(this.poNumber.field);

                if (res.status !== 200) {
                    this.submissionError = true;
                    this.isFetching = false;
                    submitButton.disabled = false;
                    this.message = res.Message;
                } else {
                    if (isProd) {
                        window.location = `/portal/checkout/order-confirmation?orderNumber=${res.orderNumber}`;
                    } else {
                        window.location = `/order-confirmation.html?orderNumber=${res.orderNumber}`;
                    }
                }
            },
        },
        created() {
            this.setValues();
            document.querySelector('.js--cartIcon').style.display = 'none';
        },
    });
}

function init() {
    hideCartIcon();
}

export default init;
